module.exports = __webpack_public_path__ + "img/pc_3.594a13ad.png";